export function Spinner({ label = 'Cargando…' }: { label?: string }) {
  return (
    <div className="flex items-center gap-3 text-ink-muted text-sm py-10 justify-center" role="status">
      <span className="w-4 h-4 rounded-full border-2 border-terracotta border-t-transparent animate-spin" />
      {label}
    </div>
  );
}
